/**
 * Created by Greg on 3/30/2016.
 */
import React from 'react';
import {Modal, Button, Popover, OverlayTrigger, Row, Col, Form, FormGroup, FormControl} from 'react-bootstrap';
import DraggableModalDialog from './../DraggableModal';
import { connect } from 'react-redux';
import {depthFirstConnected, basicDijkstra, getPath, getPaths} from './PathComputations';


var ShortestPathDialog = React.createClass({
    getInitialState() {
        let node = this.props.net.nodes[0];
        return {pathObj:null, connected: depthFirstConnected(this.props.net),
        src: node? node.id: null, dst: '_ALL_'};
    },

    componentWillReceiveProps(nextProps) {
        let node = nextProps.net.nodes[0];
        this.setState( {pathObj:null, connected: depthFirstConnected(nextProps.net),
        src: node? node.id: null, dst: '_ALL_'});

    },

    srcChange(e) {
        this.setState({src: e.target.value});
    },

    dstChange(e) {
        this.setState({dst: e.target.value});
    },

    helpPopover(){
        return (<Popover id="ShortestPathHelpPopover" title="Shortest Path Help">
            <p>This command computes the shortest paths for a <em>connected</em> network.</p>
        </Popover>)
    },

    isError () {
        if (!this.state.connected) {
            return true;
        }
        if (this.state.src === this.state.dst) {
            return true;
        }
        if (!this.state.src) { // Empty network
            return true;
        }
        return false;
    },

    computeHandler() {
        let net = this.props.net;
        let result = basicDijkstra(net, this.state.src);
        let pathList, id, desc;
        if (this.state.dst === "_ALL_") {
            pathList = getPaths(this.state.src, result.previous, net);
            id = "Shortest_" + this.state.src + "_All";
            desc = "Shortest paths from node " + this.state.src;
        } else {
            pathList = [getPath(this.state.src, this.state.dst, result.previous, net)];
            id = "Shortest_" + this.state.src + "_" + this.state.dst;
            desc = "Shortest path from node " + this.state.src + " to node "  + this.state.dst;
        }
        let pathGroup = {id: id, desc: desc, pathList: pathList};
        this.setState({pathGroup: pathGroup});
    },

    applyHandler() {
        if (this.state.pathGroup) {
            this.props.pathCollectionAdd(this.state.pathGroup);
        }
        this.setState({pathGroup: null});
    },

    textAreaValue() {
        if (!this.state.connected) {
            return "Cannot compute tree, Network is disconnected";
        }
        if (this.state.src === this.state.dst) {
            return "Source and destination must be different";
        }
        if (!this.state.src) {
            return "You must choose a source node";
        }
        if (this.state.pathGroup) {
            return JSON.stringify(this.state.pathGroup, null, 2);
        }
        return "";
    },


    render(){
        let nodes = this.props.net.nodes.map(n=>n.id).sort(); // Nodes as a array of strings
        let srcOptions = nodes.map(nstr => <option key={"src_" + nstr} value={nstr}>{nstr}</option>);
        let destOptions = nodes.map(nstr => <option key={"dst_" + nstr} value={nstr}>{nstr}</option>);
        destOptions.unshift(<option value="_ALL_" key="dst_ALL">All</option>);
        return(
        <Modal show={this.props.open} onHide={this.props.close} dialogClassName="min-span-modal"
               dialogComponentClass={DraggableModalDialog}
           enforceFocus={false} backdrop={false} >
            <Modal.Header closeButton>
                <Modal.Title>Shortest Paths</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{paddingBottom: 0}}>
                <Form horizontal>
                    <FormGroup controlId="srcDstNodes">
                    <Col sm={2}>
                        Source
                        </Col>
                        <Col sm={4}>
                        <FormControl componentClass="select" onChange={this.srcChange} value={this.state.src}>
                            {srcOptions}
                            </FormControl>
                            </Col>
                        <Col sm={2}>
                        Dest
                        </Col>
                        <Col sm={4}>
                        <FormControl componentClass="select" onChange={this.dstChange} value={this.state.dst}>
                            {destOptions}
                            </FormControl>
                            </Col>
                         </FormGroup>
                    <FormControl componentClass="textarea" readOnly
                                 value={this.textAreaValue()}
                                 rows={5} style={{resize: "none"}}/>
                    </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle="primary"
                            onClick={this.computeHandler} disabled={this.isError()}>Compute </Button>
                <Button onClick={this.applyHandler} >Apply</Button>
                <OverlayTrigger trigger="click" placement="top" overlay={this.helpPopover()}>
                    <Button bsStyle={'info'}>Help</Button>
                </OverlayTrigger>
            </Modal.Footer>
            </Modal> 
    )}
});



const mapStateToProps = (state) => {
    return {
        open: state.uiState.showShortPathModal,
        net: state.net,
        paths: state.paths
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        close: () => {
            dispatch({type: 'CLOSE_SHORT_PATH_DIALOG'});
        },
        pathCollectionAdd: (pathObj) => {
            dispatch({type: 'PATH_COLLECTION_ADD', pathObj: pathObj});
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShortestPathDialog)




// WEBPACK FOOTER //
// ./src/pathComp/ShortestPathDialog.js